/* eslint-disable @typescript-eslint/no-explicit-any */
import { BatchOperationAdd, BatchOperationUpdate, ConcurrencyError, IRListItem } from '@rhybus/api'
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { INQUIRIES } from '../../Configuration'
import { sitePath } from '../../assets/ts/api/api'
import { mpfRListsHttp } from '../../assets/ts/api/mpf-r-lists-http'
import { getSectionByCodeOrName } from '../../assets/ts/data/common-metadata'
import { transactionBatch } from '../../assets/ts/data/data'
import { LIST_NAME as DISCUSSION_LIST_NAME } from '../../assets/ts/data/discussions'
import { LIST_NAME as DUEOUT_LIST_NAME } from '../../assets/ts/data/dueout/dueout'
import { LIST_NAME as DUEOUT_DISCUSSION_LIST } from '../../assets/ts/data/dueout/dueout-discussions'
import { LIST_NAME as DUEOUT_HISTORY_LIST } from '../../assets/ts/data/dueout/dueout-history'
import { LIST_NAME } from '../../assets/ts/data/inquiry/inquiry'
import { LIST_NAME as HISTORY_LIST_NAME } from '../../assets/ts/data/inquiry/inquiry-history'
import { getUsers } from '../../assets/ts/data/users'
import {
  encodeHTML,
  formatBody,
  handleRoute,
  sendEmail,
  sendNotification,
  updateInvolvedUsers,
} from '../../assets/ts/general/general'
import { MetadataContext } from '../../store/metadata-context-provider'
import { UserContext } from '../../store/user-context-provider'
import {
  ACTIONS,
  COMMENT_TYPES,
  CONCURRENCY_ERR_MSG,
  DISCUSSION_LOG,
  INQUIRY_STATUS_IDS,
  ROLE_CODE,
} from '../../utils/constants/global-constants'
import CustomSelect from '../../utils/controls/custom-select'
import InputCheckbox from '../../utils/controls/input-checkbox'
import InputTextArea from '../../utils/controls/input-text-area'
import { Priority } from '../../utils/controls/select-options-data'
import Alert from '../alert/alert'
import DialogBox from '../alert/dialog-box'
import PageOverlayBusy from '../page-overlay/page-overlay-busy'
import ActionButtons from './action-buttons'
import Buttons from './buttons'
import './buttons.css'

interface Props {
  action: string
  actionBtnShowHide
  assignToOptions
  buttonColor: string
  currentUserRole: string
  icon: string
  id?: any
  isDueOut: boolean
  multipleItems?: any
  name: string
  popupBtnRef: React.RefObject<HTMLInputElement>
  popupClassName: string
  popupCloseOpenFunctionality: (
    type: string,
    value: number,
    top: number,
    xPosition: number,
    left: number,
    elementHeight: number,
    offsetWidth: number
  ) => void
  setActionBtnShowHide
  setDisableCheckBox
  setRefresh: (refresh: boolean) => void
  showHide: boolean
  singleItem
  statusRelativeToUser: string
  style: React.CSSProperties
}

const AssignToButton = (props: Props) => {
  const {
    action,
    assignToOptions,
    buttonColor,
    currentUserRole,
    icon,
    id,
    multipleItems,
    name,
    popupBtnRef,
    popupClassName,
    popupCloseOpenFunctionality,
    setDisableCheckBox,
    setRefresh,
    showHide,
    singleItem,
    statusRelativeToUser,
    style,
  } = props
  const { me } = useContext(UserContext)
  const { categories, sectionOptions, subcategories, tooltipObj } =
    useContext(MetadataContext)
  const [alertMessage, setAlertMessage] = useState<string>('')
  const [selected, setSelected] = useState<string>('Self')

  const [displayAlert, setDisplayAlert] = useState<boolean>(false)
  const [hideOtherSection, setHideOtherSection] = useState<boolean>(false)

  const [categoryOptions, setCategoryOptions] = useState()
  const [subCateOptions, setSubCateOptions] = useState()
  const [showErrorMsgs, setShowErrorMsgs] = useState({
    AssignTo: { show: false },
    Category: { show: false },
    Section: { show: false },
    UserId: { show: false },
    comment: { show: false },
  })
  const [userInputs, setUserInputs] = useState({
    Other: {
      AssignTo: '',
      Category: singleItem?.CategoryCode,
      Priority: singleItem?.Priority,
      SubCategory: singleItem?.SubCategoryCode,
      UserId: '',
      comment: '',
    },
    OtherSection: {
      AssignTo: '',
      Category: '',
      Priority: singleItem?.Priority,
      ResponseRequired: false,
      Section: '',
      SubCategory: null,
      comment: '',
    },
    Self: {
      AssignTo: '',
      Category: singleItem?.CategoryCode,
      Priority: singleItem?.Priority,
      SubCategory: singleItem?.SubCategoryCode,
      UserId: me.userId,
      comment: '',
    },
  })
  const [selectUser, setSelectUser] = useState([{}])

  const [userRole, setUserRole] = useState('')

  const [assignedToMe, setAssignedToMe] = useState<boolean>(false)
  const [showPageOverlay, setShowPageOverlay] = useState<boolean>(false)
  const [showConfirmReload, setShowConfirmReload] = useState<boolean>(false)
  const navigate = useNavigate()

  useEffect(() => {
    if (singleItem) {
    setUserRole(currentUserRole)
    }

  }, [userInputs, selectUser, singleItem])

  function formatStringToUserFriendly(inputString) {
    // Replace underscores and hyphens with spaces
    let formattedString = inputString.replace(/[_-]/g, ' ')
    
    // Capitalize each word
    if (formattedString.includes('CSS')) return 'CSS'
    formattedString = formattedString.split(' ').map(word => 
        word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    ).join(' ')
    return formattedString
}

  const getSectionOptions = (singleItem, multipleItems) => {
    const referenceValue = singleItem?.SectionCode
      ? singleItem?.SectionCode // Use SectionCode if singleItem is truthy
      : getUniqueSection(multipleItems) // Otherwise, use getUniqueSection for multipleItems

    return [
      { label: 'Select', value: null },
      ...sectionOptions.filter(
        (section) => referenceValue !== section.value && section.value !== -1
      ),
    ]
  }

  const handleSingleSubmit = async (selected) => {
    const isValid = validateInputs(selected)

    if (isValid) {
      setShowPageOverlay(true)
      const itemTime = new Date()
      const currUser = currentUserRole.replace(
        '[SECTION_NAME]',
        singleItem['Section/MetadataValue']
      )
      
      const getSection = async (code) => {
        const section = await getSectionByCodeOrName({
          code: code,
          isArchivedFilter: null,
        })
        return section
      }

      const dataObj = {
        AssignedTo: userInputs[selected].UserId,
        CategoryCode: userInputs[selected]?.Category,
        InvolvedUsers: updateInvolvedUsers(singleItem, me.userId),
        ItemModified: itemTime,
        ItemModifiedBy: me.userId,
        PreviousCategoryCode: singleItem.CategoryCode,
        PreviousStatusCode: singleItem.StatusCode,
        PreviousSubCategoryCode: singleItem.SubCategoryCode,
        Priority: userInputs[selected].Priority,
        StatusCode: userInputs[selected].AssignTo,
        SubCategoryCode: userInputs[selected].SubCategory,
        eKey: singleItem.eKey,
        eTag: singleItem.eTag,
      }
      const discussionObj = {
        Comment: encodeHTML(userInputs[selected].comment.trim()),
        CommentType: COMMENT_TYPES.Internal,
        InquiryGUID: singleItem.InquiryGUID,
        InquiryID: singleItem.InquiryID,
        IsActionComment: true,
        ItemCreated: itemTime,
        ItemCreatedBy: me.userId,
        ItemModified: itemTime,
        ItemModifiedBy: me.userId,
        Subject: `${DISCUSSION_LOG.Assigned} ${
          userInputs.OtherSection.Section !== ''
            ? await getSection(userInputs.OtherSection.Section)
            : formatStringToUserFriendly(userInputs[selected].AssignTo)
        }`,
        UserRole: userRole,
      }
      const historyObj = {
        ActionCode: ACTIONS[selected],
        InquiryGUID: singleItem.InquiryGUID,
        InquiryID: singleItem.InquiryID,
        ItemCreated: itemTime,
        ItemCreatedBy: me.userId,
        ItemModified: itemTime,
        ItemModifiedBy: me.userId,
        PreviousStatusCode: singleItem.StatusCode,
        SectionCode: singleItem.SectionCode,
        ServicingBy: singleItem.CurrentlyServicingBy || singleItem.ServicingBy,
        StatusCode: userInputs[selected].AssignTo,
        UserRole: userRole,
      }
      await createListObjects(selected, dataObj || {}, historyObj || {}, discussionObj || {})

      if (singleItem.InquiryID) {
        try {
          // const inquiryList = await mpfRListsHttp().getList(LIST_NAME)
          // const successful = await inquiryList.addOrUpdateItem(dataObj as IRListItem)
          const batchResult: any = await transactionBatch([
            { data: dataObj, list: LIST_NAME, op: BatchOperationUpdate },
            {
              data: historyObj,
              list: HISTORY_LIST_NAME,
              op: BatchOperationAdd,
            },
            {
              data: discussionObj,
              list: DISCUSSION_LIST_NAME,
              op: BatchOperationAdd,
            },
          ])

          if (batchResult.result === 'PASS') {
            const inquiryList = await mpfRListsHttp().getList(LIST_NAME)
            await handleEmails(me, singleItem)
            const newData: any = await inquiryList
              .query()
              .select(
                'AssignedTo',
                'AssignedTo/edipi',
                'AssignedTo/email',
                'AssignedTo/firstname',
                'AssignedTo/lastname',
                'SectionCode',
                'Section/MetadataValue'
              )
              .expand('AssignedTo', 'Section')
              .filter(`eKey eq '${dataObj.eKey}'`)
              .get()
            await sendNotification(
              historyObj.ActionCode,
              {
                ...singleItem,
                AssignedTo: newData[0].AssignedTo,
                newSection: newData[0]['Section/MetadataValue'],
              },
              me,
              currUser,
              props?.isDueOut
            )
            if (userInputs.OtherSection.Section 
              && userInputs.OtherSection.ResponseRequired === false) {
                navigate(`${INQUIRIES}`)
            } else{
              setRefresh(true) // Trigger re-render
            }
          }
        } catch (error) {
          if (error instanceof ConcurrencyError) {
            setShowConfirmReload(true)
          } else {
            console.error(error)
          }
        }
      } else {
        try {
          const batchResult: any = await transactionBatch([
            { data: dataObj, list: DUEOUT_LIST_NAME, op: BatchOperationUpdate },
            {
              data: historyObj,
              list: DUEOUT_HISTORY_LIST,
              op: BatchOperationAdd,
            },
            {
              data: discussionObj,
              list: DUEOUT_DISCUSSION_LIST,
              op: BatchOperationAdd,
            },
          ])
          if (batchResult.result === 'PASS') {
            await handleEmails(me, singleItem)
          }
          setRefresh(true) // Trigger re-render
          // }
        } catch (error) {
          console.error(error)
        }
      }
    }
    setShowPageOverlay(false)
  }
  const noItemsSelectedValidation = (multipleItems) => {
    if (multipleItems.length === 0) {
      setAlertMessage('Please select an inquiry.')
      setDisplayAlert(true)
      return false
    }
    return true
  }

  const handleMultipleSubmit = async (selected) => {
    const isValid = validateInputs(selected)

    function userRoleAndCurrentlyServicingByCheck(currentUserRole, multipleItems) {
      const servicingByValues = multipleItems.map((item) => item.CurrentlyServicingBy)
      const currentlyServicingBySame = new Set(servicingByValues).size === 1
      if (multipleItems.length === 0) {
        return false
      }
      if (!currentlyServicingBySame) {
        setAlertMessage("You don't have permission to perform this action on the selected item(s).")
        setDisplayAlert(true)
        return false
      }

      if (currentUserRole === 'MPF Leadership' && servicingByValues.includes('CSS')) {
        setAlertMessage("You don't have permission to perform this action on the selected item(s).")
        setDisplayAlert(true)
        return false
      } else if (currentUserRole === 'CSS' && servicingByValues.includes('MPF')) {
        setAlertMessage("You don't have permission to perform this action on the selected item(s).")
        setDisplayAlert(true)
        return false
      }

      return true
    }

    userRoleAndCurrentlyServicingByCheck(currentUserRole, multipleItems)
    if (isValid && userRoleAndCurrentlyServicingByCheck(currentUserRole, multipleItems)) {
      setShowPageOverlay(true)
      try {
        const successful = await sendBatchToServer(2, multipleItems, performInquiryBatch)
        if (successful !== undefined) {
          await sendBatchToServer(1, multipleItems, performDiscussionBatch)
          await sendBatchToServer(1, multipleItems, performHistoryBatch)
          // multipleItems.forEach(async (item)=>{
          //   await handleEmails(me, item)
          // }) // Will be implemented once notification is added for assign to.
          setDisableCheckBox(false)
          location.reload()
        }
      } catch (error) {
        if (error instanceof ConcurrencyError) {
          setShowConfirmReload(true)
        } else {
          console.error(error)
        }
      }
    }
    setShowPageOverlay(false)
  }
  const handleEmails = async (userdetails, data) => {
    const userId = userdetails.userId
    const isInquiry = !props?.isDueOut
    const detailView = isInquiry ? 'detailview' : 'dueoutdetailview'
    const dataGUID = isInquiry ? data?.InquiryGUID : data?.DueOutGUID
    const dataID = isInquiry ? data?.InquiryID : data?.DueOutID

    const navURL = sitePath + `/${detailView}/${dataGUID}`
    let emailBody = ''

    const emailSubject = `${isInquiry ? 'Inquiry' : 'Due Out'} '${dataID}' has been self-assigned`

    if (emailBody === '') emailBody = emailSubject

    const emailBodyData = {
      ...data,
      Title: emailSubject,
      bodyText: emailBody,
      isInquiry: true,
    }

    const body = formatBody(action, emailBodyData, navURL)
    const to = data.Customer.userID

    const emailObjData = {
      ...data,
      Action: action,
      ItemGUID: dataGUID,
      ItemID: dataID,
      Title: data?.Subject,
    }

    const emails: Promise<any>[] = []

    if (to && to !== userId.toString()) {
      emails.push(
        sendEmail({
          bcc: '',
          body: body,
          bodySurvey: '',
          cc: '',
          isDiscussion: false,
          isSurvey: false,
          loginuserId: userId,
          navURL: navURL,
          singleItem: emailObjData,
          subject: emailSubject,
          to: to,
        })
      )
    }

    if (data?.TeamMembers && data?.TeamMembers.length > 0) {
      const teamMembers = data?.TeamMembers
      for (const teamMember of teamMembers) {
        emails.push(
          sendEmail({
            bcc: '',
            body: body,
            bodySurvey: '',
            cc: '',
            isDiscussion: false,
            isSurvey: false,
            loginuserId: userId,
            navURL: navURL,
            singleItem: emailObjData,
            subject: emailSubject,
            to: teamMember.userID,
          })
        )
      }
    }

    await Promise.all(emails)
  }

  const createListObjects = async (title, dataObj, historyObj, discussionObj) => {
    if (singleItem.InquiryID) {
      switch (title) {
        case 'Self':
          historyObj.AssignedTo = userInputs[title].UserId
          break
        case 'Other':
          dataObj.AssignedTo = userInputs[title].UserId
          historyObj.AssignedTo = userInputs[title].UserId

          break
        case 'OtherSection':
          dataObj.AssignedTo = ''
          dataObj.ResponseRequired = userInputs[title].ResponseRequired
          dataObj.SectionCode = userInputs[title].Section
          dataObj.PreviousSectionCode = singleItem.SectionCode
          dataObj.StatusCode = INQUIRY_STATUS_IDS.Submitted
          historyObj.StatusCode = INQUIRY_STATUS_IDS.Submitted
          historyObj.SectionCode = userInputs[title].Section
          historyObj.PreviousSectionCode = singleItem.SectionCode
          break
      }
    } else {
      discussionObj.DueOutGUID = historyObj.DueOutGUID = singleItem.DueOutGUID
      discussionObj.DueOutID = historyObj.DueOutID = singleItem.DueOutID
      historyObj.StatusCode = singleItem.StatusCode
      historyObj.PreviousStatusCode = singleItem.PreviousStatusCode
      historyObj.AssignedTo = userInputs[title].UserId
      historyObj.WaitingOnUserRole = userInputs[title].AssignTo

      delete dataObj.StatusCode
      delete dataObj.PreviousStatusCode
      delete historyObj.InquiryGUID
      delete historyObj.InquiryID
      delete discussionObj.InquiryGUID
      delete discussionObj.InquiryID
    }
  }

  const validateInputs = (type) => {
    let isValid = true
    const validityObj = showErrorMsgs

    Object.keys(showErrorMsgs).forEach((requiredInput) => {
      if (requiredInput === 'AssignTo' && userInputs[type][requiredInput] === '') {
        isValid = true
      } else {
        if (
          userInputs[type][requiredInput] === '' ||
          userInputs[type][requiredInput] === 'Select' ||
          userInputs[type][requiredInput] === null
        ) {
          validityObj[requiredInput].show = true

          isValid = false
        } else {
          validityObj[requiredInput].show = false
        }
      }
    })

    setShowErrorMsgs({ ...validityObj })
    return isValid
  }

  function getRoleCode(pascode: string, servicingOrg: string, assignto: string): string {
    const officeCode = servicingOrg.replace(' ', ' FSS-')
    const roleParts = assignto.split(' ').join('_')
    let formattedRole: string
    if (roleParts === 'CSS') {
      const PASlastFour = pascode.slice(-4)
      formattedRole = `${PASlastFour}-${roleParts}`
    } else if (roleParts === 'MPF_Leadership') {
      formattedRole = 'Leadership'
    } else formattedRole = ROLE_CODE[roleParts]

    return `${officeCode}-${formattedRole}`
  }

  const resetAssignToInputs = (buttonType) => {
    if (buttonType === 'single') {
      const category = singleItem?.CategoryCode
      const priority = singleItem?.Priority
      const subcategory = singleItem?.SubCategoryCode
      if (selected === 'Self') {
        setUserInputs({
          ...userInputs,
          Self: {
            AssignTo: statusRelativeToUser,
            Category: category,
            Priority: priority,
            SubCategory: subcategory,
            UserId: me.userId,
            comment: '',
          },
        })
      } else if (selected === 'Other') {
        setUserInputs({
          ...userInputs,
          Other: {
            AssignTo: statusRelativeToUser,
            Category: category,
            Priority: priority,
            SubCategory: subcategory,
            UserId: '',
            comment: '',
          },
        })
      } else if (selected == 'OtherSection') {
        setUserInputs({
          ...userInputs,
          OtherSection: {
            AssignTo: '',
            Category: '',
            Priority: '',
            ResponseRequired: false,
            Section: '',
            SubCategory: null,
            comment: '',
          },
        })
      }
    }
    if (buttonType === 'multiple') {
      if (selected === 'Self') {
        setUserInputs({
          ...userInputs,
          Self: {
            AssignTo: statusRelativeToUser,
            Category: '',
            Priority: '',
            SubCategory: '',
            UserId: me.userId,
            comment: '',
          },
        })
      } else if (selected === 'Other') {
        setUserInputs({
          ...userInputs,
          Other: {
            AssignTo: statusRelativeToUser,
            Category: '',
            Priority: '',
            SubCategory: '',
            UserId: '',
            comment: '',
          },
        })
      } else if (selected == 'OtherSection') {
        setUserInputs({
          ...userInputs,
          OtherSection: {
            AssignTo: '',
            Category: '',
            Priority: '',
            ResponseRequired: false,
            Section: '',
            SubCategory: null,
            comment: '',
          },
        })
      }
    }
    setShowErrorMsgs({
      AssignTo: { show: false },
      Category: { show: false },
      Section: { show: false },
      UserId: { show: false },
      comment: { show: false },
    })
  }

  const changeHandler = (e: any) => {
    setSelected(e.target.value)
    resetAssignToInputs(singleItem ? 'single' : 'multiple')
  }

  const handleResponseRequested = (e: any) => {
    setUserInputs({
      ...userInputs,
      OtherSection: {
        ...userInputs.OtherSection,
        ResponseRequired: e.target.checked,
      },
    })
  }

  /**handleAssignToChange
   * Only applies to Other
   */
  const handleAssignToChange = async (e) => {
    const { label, value } = e
    let pascode
    let servicingOrg
    if (singleItem) {
      const { PASCODE, ServicingOrganization } = singleItem
      pascode = PASCODE
      servicingOrg = ServicingOrganization
    } else if (multipleItems) {
      const PASCODE = getUniquePASCODE(multipleItems)
      const ServicingOrganization = getUniqueServicingOrg(multipleItems)
      pascode = PASCODE
      servicingOrg = ServicingOrganization
    }
    if (label !== 'Select') {
      const assignToUserIn = getRoleCode(pascode, servicingOrg, label)
      const users = await getUsers({ search: `roles eq '${assignToUserIn}'` })
      const getFilteredUsers = (users, singleItem, multipleItems, me) => {
        const assignedToUserId = singleItem?.AssignedTo?.userID
          ? singleItem?.AssignedTo?.userID // Use AssignedTo.userID for singleItem if truthy
          : getUniqueAssignTo(multipleItems) // Otherwise, use getUniqueAssignTo for multipleItems

        return users.filter(
          (selfOrCurAssignedTo) =>
            me.userId !== selfOrCurAssignedTo.userId &&
            assignedToUserId !== selfOrCurAssignedTo.userId
        )
      }

      const filteredUsers = getFilteredUsers(users, singleItem, multipleItems, me)

      const userList = filteredUsers.map((person) => ({
        label: person.defaultDisplay,
        value: person.userId,
      }))

      setSelectUser([{ label: 'Select', value: '' }, ...userList])
      setUserInputs({
        ...userInputs,
        Other: {
          ...userInputs.Other,
          AssignTo: value,
          UserId: '',
        },
      })
    } else {
      setUserInputs({
        ...userInputs,
        Other: {
          ...userInputs.Other,
          AssignTo: '',
          UserId: '',
        },
      })
    }
  }

  const onChangeSelectUser = (e: any) => {
    const { value } = e
    setUserInputs((prevState) => ({
      ...prevState,
      [selected]: {
        ...prevState[selected],
        UserId: value,
      },
    }))
  }
  const onChangeCategory = (e: any) => {
    const { value } = e
    setUserInputs((prevState) => ({
      ...prevState,
      [selected]: {
        ...prevState[selected],
        Category: value,
        SubCategory: null,
      },
    }))
    const subCateOptions = findSubCategory(value, subcategories)
    setSubCateOptions(subCateOptions)
  }
  const onChangeSubCategory = (e: any) => {
    const { value } = e
    setUserInputs((prevState) => ({
      ...prevState,
      [selected]: {
        ...prevState[selected],
        SubCategory: value,
      },
    }))
  }
  const onChangePriority = (e: any) => {
    const { value } = e
    setUserInputs((prevState) => ({
      ...prevState,
      [selected]: {
        ...prevState[selected],
        Priority: value,
      },
    }))
  }
  const onChangeSection = (e: any) => {
    const { label, value } = e
    //Section is only changed on Assign To Other Section.
    const assignToValue = INQUIRY_STATUS_IDS.Submitted
    setUserInputs((prevState) => ({
      ...prevState,
      [selected]: {
        ...prevState[selected],
        AssignTo: assignToValue,
        Category: null,
        Section: value,
        SubCategory: null,
      },
    }))
    const cateOptions = findCategory(value, categories)
    setCategoryOptions(cateOptions)
  }
  const changeComment = (e) => {
    setUserInputs((prevState) => ({
      ...prevState,
      [selected]: {
        ...prevState[selected],
        comment: e.target.value,
      },
    }))
  }

  const findCategory = (sectionCode, cate) => {
    // Find the object in category where the ParentSectionCode matches the SectionCode of the found object in section
    const categoryArray = cate
      .filter((obj) => obj.ParentSectionCode === sectionCode)
      .map((obj) => {
        return {
          label: obj?.Category,
          value: obj?.CategoryCode,
        }
      })

    // Return the Category of the found object in category
    return [{ label: 'Select', value: null }, ...categoryArray]
  }
  const findSubCategory = (categoryCode, subCate) => {
    // Find the object in category where the ParentSectionCode matches the SectionCode of the found object in section
    const subCategoryArray = subCate
      .filter((obj) => obj.ParentCategoryCode === categoryCode)
      .map((obj) => {
        return {
          label: obj?.SubCategory,
          value: obj?.SubCategoryCode,
        }
      })
    // Return the Category of the found object in category
    return [{ label: 'Select', value: null }, ...subCategoryArray]
  }
  const getUniqueServicingOrg = (multipleItems) => {
    if (multipleItems.length > 0) {
      const servicingOrgSet = new Set(multipleItems.map((item) => item.ServicingOrganization))
      if ([...servicingOrgSet].length === 1) {
        return [...servicingOrgSet][0]
      } else {
        console.error('Multiple Servicing Orgs Selected')
        return [...servicingOrgSet]
      }
    } else {
      return new Set([])
    }
  }
  const getUniquePASCODE = (multipleItems) => {
    if (multipleItems.length > 0) {
      const pascodeSet = new Set(multipleItems.map((item) => item.PASCODE))
      return [...pascodeSet]
    } else {
      return new Set([])
    }
  }
  const getUniqueSection = (multipleItems) => {
    if (multipleItems.length > 0) {
      const sectionSet = new Set(multipleItems.map((item) => item.SectionCode))
      return [...sectionSet][0]
    } else {
      return new Set([])
    }
  }
  const getUniqueInquiryID = (multipleItems) => {
    if (multipleItems.length > 0) {
      const inquiryIDSet = new Set(multipleItems.map((item) => item.InquiryID))
      return [...inquiryIDSet][0]
    } else {
      return new Set([])
    }
  }
  const getUniqueAssignTo = (multipleItems) => {
    if (multipleItems.length > 0) {
      const assignToSet = new Set(multipleItems.map((item) => item?.AssignedTo?.userID))
      return [...assignToSet][0]
    } else {
      return new Set([])
    }
  }
  const getUniqueSectionValue = (multipleItems) => {
    if (multipleItems.length > 0) {
      const sectionSet = new Set(multipleItems.map((item) => item['Section/MetadataValue']))
      return [...sectionSet][0]
    } else {
      return ''
    }
  }
  async function sendToServer(batchItems) {
    // Simulate async server request
    return await mpfRListsHttp().createBatch(2, batchItems).execute()
  }
  async function sendBatchToServer(batchType, batchItems, performBatchFunction) {
    try {
      const result = await performBatchFunction(batchType, batchItems)
      return result !== undefined ? result : true
    } catch (error) {
      console.error('Multiple Elevate', error)
    }
  }
  const performInquiryBatch = async (batchOperation, multipleItems) => {
    const createInquiryObjArray = (
      rr,
      assignedTo,
      categoryCode,
      itemModified,
      itemModifiedBy,
      previousStatusCode,
      priority,
      previousSectionCode,
      sectionCode,
      statusCode,
      subCategoryCode,
      eKey,
      eTag
    ) => ({
      AssignedTo: assignedTo,
      CategoryCode: categoryCode,
      ItemModified: itemModified,
      ItemModifiedBy: itemModifiedBy,
      PreviousSectionCode: previousSectionCode,
      PreviousStatusCode: previousStatusCode,
      Priority: priority,
      ResponseRequired: rr,
      SectionCode: sectionCode,
      StatusCode: statusCode,
      SubCategoryCode: subCategoryCode,
      eKey: eKey,
      eTag: eTag,
    })
    const batchInquiryItems: any = []

    const jsonResults = multipleItems || []
    const itemTime = new Date()
    const leadershipUser = userInputs[selected].AssignTo?.split('-')[1]
    const isLeadershipUser = leadershipUser === 'MPF_LEADERSHIP'
    jsonResults.forEach((result) => {
      const { SectionCode, StatusCode, eKey, eTag } = result
      const inquiryArray = createInquiryObjArray(
        userInputs[selected].ResponseRequired,
        userInputs[selected].UserId,
        userInputs[selected]?.Category,
        itemTime,
        me.userId,
        StatusCode,
        userInputs[selected].Priority,
        SectionCode,
        userInputs[selected].Section,
        isLeadershipUser ? leadershipUser : userInputs[selected].AssignTo,
        userInputs[selected].SubCategory,
        eKey,
        eTag
      )
      batchInquiryItems.push({
        data: inquiryArray,
        list: LIST_NAME,
        op: batchOperation,
      })
    })

    await sendToServer(batchInquiryItems)
  }
  const performDiscussionBatch = async (batchOperation, multipleItems) => {
    const createDiscussionObjArray = (
      comment,
      commentType,
      inquiryGUID,
      inquiryID,
      isActionComment,
      itemCreated,
      itemCreatedBy,
      itemModified,
      itemModifiedBy,
      subject,
      userRole
    ) => ({
      Comment: comment,
      CommentType: commentType,
      InquiryGUID: inquiryGUID,
      InquiryID: inquiryID,
      IsActionComment: isActionComment,
      ItemCreated: itemCreated,
      ItemCreatedBy: itemCreatedBy,
      ItemModified: itemModified,
      ItemModifiedBy: itemModifiedBy,
      Subject: subject,
      UserRole: userRole,
    })
    const batchInquiryDiscussionsItems: any = []

    const jsonResults = multipleItems || []
    const itemTime = new Date()

    jsonResults.forEach(async (result) => {
      const { InquiryGUID, InquiryID } = result
      const currUser = currentUserRole.replace('[SECTION_NAME]', result['Section/MetadataValue'])
      const getSection = async (code) => {
        const section = await getSectionByCodeOrName({
          code: code,
          isArchivedFilter: null,
        })
        return section
      }
      const inquiryDiscussionsArray = createDiscussionObjArray(
        encodeHTML(userInputs[selected].comment.trim()),
        COMMENT_TYPES.Internal,
        InquiryGUID,
        InquiryID,
        true,
        itemTime,
        me.userId,
        itemTime,
        me.userId,
        `${DISCUSSION_LOG.Assigned} ${
          userInputs.OtherSection.Section !== ''
            ? await getSection(userInputs.OtherSection.Section)
            : result['Section/MetadataValue']
        }`,
        currUser
      )
      batchInquiryDiscussionsItems.push({
        data: inquiryDiscussionsArray,
        list: DISCUSSION_LIST_NAME,
        op: batchOperation,
      })
    })
    return await sendToServer(batchInquiryDiscussionsItems)
  }
  const performHistoryBatch = async (batchOperation, multipleItems) => {
    const createHistoryObjArray = (
      actionCode,
      inquiryGUID,
      inquiryID,
      itemCreated,
      itemCreatedBy,
      itemModified,
      itemModifiedBy,
      previousSectionCode,
      previousStatusCode,
      sectionCode,
      servicingBy,
      statusCode,
      userRole
    ) => ({
      ActionCode: actionCode,
      InquiryGUID: inquiryGUID,
      InquiryID: inquiryID,
      ItemCreated: itemCreated,
      ItemCreatedBy: itemCreatedBy,
      ItemModified: itemModified,
      ItemModifiedBy: itemModifiedBy,
      PreviousSectionCode: previousSectionCode,
      PreviousStatusCode: previousStatusCode,
      SectionCode: sectionCode,
      ServicingBy: servicingBy,
      StatusCode: statusCode,
      UserRole: userRole,
    })
    const sectionValue = getUniqueSectionValue(multipleItems)
    const batchInquiryHistoryItems: any = []
    const currUser = currentUserRole.replace('[SECTION_NAME]', sectionValue)
    const leadershipUser = userInputs[selected].AssignTo?.split('-')[1]
    const isLeadershipUser = leadershipUser === 'MPF_LEADERSHIP'
    const jsonResults = multipleItems || []
    jsonResults.forEach(async (result) => {
      const { InquiryGUID, InquiryID, SectionCode, ServicingBy, StatusCode } = result
      const itemTime = new Date()
      const inquiryHistoryArray = createHistoryObjArray(
        ACTIONS[selected],
        InquiryGUID,
        InquiryID,
        itemTime,
        me.userId,
        itemTime,
        me.userId,
        SectionCode,
        StatusCode,
        userInputs[selected].Section,
        ServicingBy,
        isLeadershipUser ? leadershipUser : userInputs[selected].AssignTo,
        currUser
      )

      batchInquiryHistoryItems.push({
        data: inquiryHistoryArray,
        list: HISTORY_LIST_NAME,
        op: batchOperation,
      })
    })

    await sendToServer(batchInquiryHistoryItems)
  }

  // This useEffect sets assign to user when it's only one option
  useEffect(() => {
    if (singleItem) {
      const assignValue = {
        category: singleItem?.CategoryCode,
        section: singleItem?.SectionCode,
      }
      const categoryOptions = findCategory(assignValue.section, categories)
      const subCategoryOptions = findSubCategory(assignValue.category, subcategories)
      setCategoryOptions(categoryOptions)
      setSubCateOptions(subCategoryOptions)
    }
  }, [singleItem])

  useEffect(() => {
    if (multipleItems.length !== 0) {
      const massSectionValue = getUniqueSection(multipleItems)
      const categoryOptions = findCategory(massSectionValue, categories)
      setCategoryOptions(categoryOptions)

      // Check for userInputs.Self.Category and update subCategoryOptions
      if (userInputs.Self.Category) {
        const subCategoryOptions = findSubCategory(userInputs.Self.Category, subcategories)
        setSubCateOptions(subCategoryOptions)
      }
    }
  }, [multipleItems, userInputs])

  useEffect(() => {
    resetAssignToInputs(singleItem ? 'single' : 'multiple')
    if (singleItem?.AssignedTo?.userID === me.userId) {
      setSelected('Other')
      setAssignedToMe(true)
    }
    if (getUniqueAssignTo(multipleItems) === me.userId) {
      setSelected('Other')
      setAssignedToMe(true)
    }
    if (singleItem?.DueOutGUID !== undefined || singleItem?.CurrentlyServicingBy === 'CSS') {
      setHideOtherSection(true)
    }
  }, [singleItem, me.userId, multipleItems, statusRelativeToUser])

  return (
    <div>
      {displayAlert && (
        <Alert
          alerttextclass='poppins-semibold font-13 text-center'
          btn1className='btn btn btn-sm font-12 poppins-semibold btn-primary whitetext border-radius text-uppercase'
          btn1iconclassNmae='icon-checked font-12 pe-1'
          btn2classNmae='btn btn btn-border1 darktext btn-sm poppins-semibold font-12 border-radius text-uppercase'
          btn2iconclassNmae='icon-close color-primary font-12 pe-1'
          cancel='Cancel'
          className='alert-info'
          message={alertMessage}
          onClick={() => {
            setAlertMessage('')
            setDisplayAlert(false)
          }}
          yes='OK'
        />
      )}
      <ActionButtons
        aria-label={name}
        className={`btn-lg font-12 ${buttonColor} whitetext text-nowrap border-radius poppins-bold text-uppercase`}
        icon={icon}
        id={id}
        isClick={action}
        label={name}
        name={name}
        popupCloseOpenFunctionality={popupCloseOpenFunctionality}
        showHide={showHide}
        type='button'
      />

      {showHide ? (
        <div
          className={`popup popup-md ${popupClassName}`}
          ref={popupBtnRef}
          style={style}
        >
          <div className='row'>
            <div className='d-flex align-items-center col-md-12 mt-0'>
              {!assignedToMe && (
                <InputCheckbox
                  formClassName='d-flex align-items-center'
                  inputProps={{
                    arialabel: 'Self',
                    checked: selected === 'Self',
                    className: 'font-12 poppins-medium title-color2 mx-2',
                    id: 'Self',
                    label: 'Self',
                    name: 'AssignOptions',
                    type: 'radio',
                    value: 'Self',
                  }}
                  onChange={changeHandler}
                />
              )}
              <InputCheckbox
                formClassName='d-flex align-items-center'
                inputProps={{
                  arialabel: 'Other',
                  checked: selected === 'Other',
                  className: 'font-12 poppins-medium title-color2 mx-2',
                  id: 'Other',
                  label: 'Other',
                  name: 'AssignOptions',
                  type: 'radio',
                  value: 'Other',
                }}
                onChange={changeHandler}
              />
              {!hideOtherSection && (
                <InputCheckbox
                  formClassName='d-flex align-items-center'
                  inputProps={{
                    arialabel: 'Other Section',
                    checked: selected === 'OtherSection',
                    className: 'font-12 poppins-medium title-color2 mx-2',
                    id: 'OtherSection',
                    label: 'Other Section',
                    name: 'AssignOptions',
                    type: 'radio',
                    value: 'OtherSection',
                  }}
                  onChange={changeHandler}
                />
              )}
            </div>
            {selected === 'Self' && (
              <div className='row'>
                <div className='col-dm-12 mt-0 mb-1'>
                  <CustomSelect
                    className='form-sm w-100 sourcesanspro font-13 customselect'
                    error={showErrorMsgs.Category.show}
                    formClassName='form-vertical text-wrap mb-2'
                    id='Category'
                    info={props.isDueOut? 
                      tooltipObj?.assignDueOutCategorySelf?.TooltipDescription
                      : tooltipObj?.assignCategorySelf?.TooltipDescription}
                    infoClassName='tool-tip tooltip-bottom-left font-12 sourcesanspro'
                    infoIcon='icon-info color-primary'
                    inputProps={{
                      className: 'mb-1 font-12 poppins-medium title-color',
                    }}
                    isInfo
                    isMandatory
                    label='Category'
                    name='Category'
                    onChange={onChangeCategory}
                    options={categoryOptions}
                    value={userInputs.Self.Category}
                  />
                </div>
                <div className='col-dm-12 mt-0 mb-1'>
                  <CustomSelect
                    className='form-sm w-100 sourcesanspro font-13 customselect'
                    formClassName='form-vertical text-wrap mb-2'
                    id='SubCategory'
                    info={props.isDueOut? 
                      tooltipObj?.assignDueOutSubCatSelf?.TooltipDescription
                      : tooltipObj?.assignSubcatSelf?.TooltipDescription}
                    infoClassName='tool-tip tooltip-bottom-left font-12 sourcesanspro'
                    infoIcon='icon-info color-primary'
                    inputProps={{
                      className: 'mb-1 font-12 poppins-medium title-color',
                    }}
                    isInfo
                    label='Sub Category'
                    name='Sub Category'
                    onChange={onChangeSubCategory}
                    options={subCateOptions}
                    value={userInputs.Self.SubCategory}
                  />{' '}
                </div>
                <div className='col-dm-12 mt-0 mb-1'>
                  <CustomSelect
                    className='form-sm w-100 sourcesanspro font-13 customselect'
                    formClassName='form-vertical text-wrap mb-2'
                    id='Priority'
                    info={props.isDueOut? 
                      tooltipObj?.assignDueOutPrioritySelf?.TooltipDescription
                      : tooltipObj?.assignPrioritySelf?.TooltipDescription}
                    infoClassName='tool-tip tooltip-bottom-left font-12 sourcesanspro'
                    infoIcon='icon-info color-primary'
                    inputProps={{
                      className: 'mb-1 font-12 poppins-medium title-color',
                    }}
                    isInfo
                    label='Priority'
                    name='Priority'
                    onChange={onChangePriority}
                    options={Priority}
                    value={userInputs.Self.Priority}
                  />{' '}
                </div>
                <div className='col-md-12 mt-0'>
                  <InputTextArea
                    className='form-lg font-13 sourcesanspro  min-h-100 p-1'
                    cols='30'
                    error={showErrorMsgs.comment.show}
                    formClassName=' form-vertical'
                    info={props.isDueOut? 
                      tooltipObj?.assignDueOutCommentSelf?.TooltipDescription
                      : tooltipObj?.assignCommentSelf?.TooltipDescription}
                    infoClassName='tool-tip tooltip-bottom-left font-12 sourcesanspro'
                      infoIcon='icon-info color-primary'
                    inputProps={{
                      className: 'font-12 poppins-medium title-color2 mb-1',
                      id: 'Comment',
                      name: 'Comment',
                      placeholder: 'Enter your Comment',
                    }}
                    isInfo
                    isMandatory
                    label='Comment'
                    onChange={changeComment}
                    rows='3'
                    type='textarea'
                  />
                </div>
              </div>
            )}
            {selected === 'Other' && (
              <div className='row'>
                <div className='col-dm-12 mt-0 mb-1'>
                  <CustomSelect
                    className='form-sm w-100 sourcesanspro font-13 customselect'
                    error={showErrorMsgs.AssignTo.show}
                    formClassName='form-vertical text-wrap mb-2'
                    id='AssignTo'
                    info={props.isDueOut ? 
                      tooltipObj?.dueOutassignTo?.TooltipDescription : 
                      tooltipObj?.assignTo?.TooltipDescription}
                    infoClassName='tool-tip tooltip-bottom-left font-12 sourcesanspro'
                    infoIcon='icon-info color-primary'
                    inputProps={{
                      className: 'mb-1 font-12 poppins-medium title-color',
                    }}
                    isInfo
                    isMandatory
                    label='Assign To'
                    name='Assign To'
                    onChange={handleAssignToChange}
                    options={assignToOptions}
                    value={userInputs.Other.AssignTo}
                  />{' '}
                </div>
                <div className='col-dm-12 mt-0 mb-1'>
                  <CustomSelect
                    className='form-sm w-100 sourcesanspro font-13 customselect'
                    error={showErrorMsgs.UserId.show}
                    formClassName='form-vertical text-wrap mb-2'
                    id='SelectUser'
                    info={props.isDueOut? 
                      tooltipObj?.dueOutassignSelectUser?.TooltipDescription
                      : tooltipObj?.assignSelectUser?.TooltipDescription}
                    infoClassName='tool-tip tooltip-bottom-left font-12 sourcesanspro'
                    infoIcon='icon-info color-primary'
                    inputProps={{
                      className: 'mb-1 font-12 poppins-medium title-color',
                    }}
                    isInfo
                    isMandatory
                    label='Select User'
                    name='Select User'
                    onChange={onChangeSelectUser}
                    options={selectUser}
                    value={userInputs.Other.UserId}
                  />
                </div>
                <div className='col-dm-12 mt-0 mb-1'>
                  <CustomSelect
                    className='form-sm w-100 sourcesanspro font-13 customselect'
                    error={showErrorMsgs.Category.show}
                    formClassName='form-vertical text-wrap mb-2'
                    id='Category'
                    info={props.isDueOut? 
                      tooltipObj?.assignDueOutCategoryOther?.TooltipDescription
                      : tooltipObj?.assignCategoryOther?.TooltipDescription}
                    infoClassName='tool-tip tooltip-bottom-left font-12 sourcesanspro'
                    infoIcon='icon-info color-primary'
                    inputProps={{
                      className: 'mb-1 font-12 poppins-medium title-color',
                    }}
                    isInfo
                    isMandatory
                    label='Category'
                    name='Category'
                    onChange={onChangeCategory}
                    options={categoryOptions}
                    value={userInputs.Other.Category}
                  />
                </div>
                <div className='col-dm-12 mt-0 mb-1'>
                  <CustomSelect
                    className='form-sm w-100 sourcesanspro font-13 customselect'
                    formClassName='form-vertical text-wrap mb-2'
                    id='SubCategory'
                    info={props.isDueOut? 
                      tooltipObj?.assignDueOutSubCatOther?.TooltipDescription
                      : tooltipObj?.assignSubcatOther?.TooltipDescription}
                    infoClassName='tool-tip tooltip-bottom-left font-12 sourcesanspro'
                    infoIcon='icon-info color-primary'
                    inputProps={{
                      className: 'mb-1 font-12 poppins-medium title-color',
                    }}
                    isInfo
                    label='Sub Category'
                    name='Sub Category'
                    onChange={onChangeSubCategory}
                    options={subCateOptions}
                    value={userInputs.Other.SubCategory}
                  />
                </div>
                <div className='col-dm-12 mt-0 mb-1'>
                  <CustomSelect
                    className='form-sm w-100 sourcesanspro font-13 customselect'
                    formClassName='form-vertical text-wrap mb-2'
                    id='Priority'
                    info={props.isDueOut? 
                      tooltipObj?.assignDueOutPriorityOther?.TooltipDescription
                      : tooltipObj?.assignPriorityOther?.TooltipDescription}
                    infoClassName='tool-tip tooltip-bottom-left font-12 sourcesanspro'
                    infoIcon='icon-info color-primary'
                    inputProps={{
                      className: 'mb-1 font-12 poppins-medium title-color',
                    }}
                    isInfo
                    label='Priority'
                    name='Priority'
                    onChange={onChangePriority}
                    options={Priority}
                    value={userInputs.Other.Priority}
                  />
                </div>
                <div className='col-md-12 mt-0'>
                  <InputTextArea
                    className='form-lg font-13 sourcesanspro  min-h-100 p-1'
                    cols='30'
                    error={showErrorMsgs.comment.show}
                    formClassName=' form-vertical'
                    info={props.isDueOut? 
                      tooltipObj?.assignDueOutCommentOther?.TooltipDescription
                      : tooltipObj?.assignCommentOther?.TooltipDescription}
                    infoClassName='tool-tip tooltip-bottom-left font-12 sourcesanspro'
                    infoIcon='icon-info color-primary'
                    inputProps={{
                      className: 'font-12 poppins-medium title-color2 mb-1',
                      id: 'Comment',
                      name: 'Comment',
                      placeholder: 'Enter your Comment',
                    }}
                    isInfo
                    isMandatory
                    label='Comment'
                    onChange={changeComment}
                    rows='3'
                    type='textarea'
                  />
                </div>
              </div>
            )}
            {selected === 'OtherSection' && (
              <div className='row'>
                <div className='col-dm-12 mt-0 mb-1'>
                  <CustomSelect
                    className='form-sm w-100 sourcesanspro font-13 customselect'
                    error={showErrorMsgs.Section.show}
                    extras={
                      <InputCheckbox
                        formClassName='d-flex align-items-center ms-auto'
                        inputProps={{
                          arialabel: 'Response Required',
                          className: 'font-12 poppins-medium title-color2 mx-2',
                          id: 'ResponseRequired',
                          label: 'Response Required',
                          name: 'ResponseRequired',
                          type: 'checkbox',
                          value: 'ResponseRequired',
                        }}
                        onChange={handleResponseRequested}
                      />
                    }
                    extrasClassName='text-right font-12 poppins-medium title-color2 ms-auto d-flex'
                    formClassName='form-vertical text-wrap mb-2 d-flex'
                    id='Section'
                    info={tooltipObj?.assignSection?.TooltipDescription}
                    infoClassName='tool-tip tooltip-bottom-left font-12 sourcesanspro'
                    infoIcon='icon-info color-primary'
                    inputProps={{
                      className: 'mb-1 font-12 poppins-medium title-color2 d-flex',
                    }}
                    isInfo
                    isMandatory
                    label='Section'
                    name='Section'
                    onChange={onChangeSection}
                    options={getSectionOptions(singleItem, multipleItems)}
                    value={userInputs.OtherSection.Section}
                  />
                </div>
                <div className='col-dm-12 mt-0 mb-1'>
                  <CustomSelect
                    className='form-sm w-100 sourcesanspro font-13 customselect'
                    error={showErrorMsgs.Category.show}
                    formClassName='form-vertical text-wrap mb-2'
                    id='Category'
                    info={tooltipObj?.assignCategoryOtherSection?.TooltipDescription}
                    infoClassName='tool-tip tooltip-bottom-left font-12 sourcesanspro'
                    infoIcon='icon-info color-primary'
                    inputProps={{
                      className: 'mb-1 font-12 poppins-medium title-color',
                    }}
                    isInfo
                    isMandatory
                    label='Category'
                    name='Category'
                    onChange={onChangeCategory}
                    options={categoryOptions}
                    value={userInputs.OtherSection.Category}
                  />
                </div>
                <div className='col-dm-12 mt-0 mb-1'>
                  <CustomSelect
                    className='form-sm w-100 sourcesanspro font-13 customselect'
                    formClassName='form-vertical text-wrap mb-2'
                    id='SubCategory'
                    info={tooltipObj?.assignSubcatOtherSection?.TooltipDescription}
                    infoClassName='tool-tip tooltip-bottom-left font-12 sourcesanspro'
                    infoIcon='icon-info color-primary'
                    inputProps={{
                      className: 'mb-1 font-12 poppins-medium title-color',
                    }}
                    isInfo
                    label='Sub Category'
                    name='Sub Category'
                    onChange={onChangeSubCategory}
                    options={subCateOptions}
                    value={userInputs.OtherSection?.SubCategory}
                  />
                </div>
                <div className='col-dm-12 mt-0 mb-1'>
                  <CustomSelect
                    className='form-sm w-100 sourcesanspro font-13 customselect'
                    formClassName='form-vertical text-wrap mb-2'
                    id='Priority'
                    info={tooltipObj?.assignPriorityOtherSection?.TooltipDescription}
                    infoClassName='tool-tip tooltip-bottom-left font-12 sourcesanspro'
                    infoIcon='icon-info color-primary'
                    inputProps={{
                      className: 'mb-1 font-12 poppins-medium title-color',
                    }}
                    isInfo
                    label='Priority'
                    name='Priority'
                    onChange={onChangePriority}
                    options={Priority}
                    value={userInputs.OtherSection.Priority}
                  />
                </div>
                <div className='col-md-12 mt-0'>
                  <InputTextArea
                    className='form-lg font-13 sourcesanspro  min-h-100 p-1'
                    cols='30'
                    error={showErrorMsgs.comment.show}
                    formClassName=' form-vertical'
                    info={tooltipObj?.assignCommentOtherSection?.TooltipDescription}
                    infoClassName='tool-tip tooltip-bottom-left font-12 sourcesanspro'
                    infoIcon='icon-info color-primary'
                    inputProps={{
                      className: 'font-12 poppins-medium title-color2 mb-1',
                      id: 'Comment',
                      name: 'Comment',
                      placeholder: 'Enter your Comment',
                    }}
                    isInfo
                    isMandatory
                    label='Comment'
                    onChange={changeComment}
                    rows='3'
                    type='textarea'
                  />
                </div>
              </div>
            )}
          </div>

          <div className='pt-2 d-flex gap-2'>
            {multipleItems && !singleItem && (
              <Buttons
                aria-label='Ok'
                className='btn btn-sm btn-primary whitetext font-11 border-radius ms-auto text-uppercase poppins-semibold'
                icon='icon-checked font-10 me-1'
                label='Ok'
                onClick={() => {
                  handleMultipleSubmit(selected)
                }}
              />
            )}
            {singleItem && (
              <Buttons
                aria-label='Ok'
                className='btn btn-sm btn-primary whitetext font-11 border-radius ms-auto text-uppercase poppins-semibold'
                icon='icon-checked font-10 me-1'
                label='Ok'
                onClick={() => {
                  handleSingleSubmit(selected)
                }}
              />
            )}

            <ActionButtons
              className='btn-border1 title-color3 btn-sm font-11 border-radius text-uppercase poppins-semibold'
              icon='icon-close font-9 me-1 color-primary'
              isClick='Cancel'
              label='Cancel'
              name='Cancel'
              onClick={() => {
                setDisableCheckBox ? setDisableCheckBox(false) : ''
                setShowErrorMsgs({
                  AssignTo: { show: false },
                  Category: { show: false },
                  Section: { show: false },
                  UserId: { show: false },
                  comment: { show: false },
                })
              }}
              popupCloseOpenFunctionality={popupCloseOpenFunctionality}
              showHide={showHide}
              type='button'
            />
          </div>
        </div>
      ) : null}
      {showPageOverlay && <PageOverlayBusy />}
      {showConfirmReload && (
        <DialogBox
          handleRouteNo={() => handleRoute('cancel', setShowConfirmReload)}
          handleRouteYes={handleRoute}
          message={CONCURRENCY_ERR_MSG}
          primaryText={'Ok'}
          secondaryText={'Cancel'}
        />
      )}
    </div>
  )
}

export default AssignToButton
